import { VueRegistration } from "@abaco/web-common/src/app";

const globals: VueRegistration = {
  "inspection-list-tile": () => import("./components/tiles/InspectionListTile.vue"),
  "inspection-map-tile": () => import("./components/tiles/InspectionMapTile.vue"),
  "inspection-editor-tile": () => import("./components/tiles/InspectionEditorTile.vue"),
  "inspection-history-tile": () => import("./components/tiles/InspectionHistoryTile.vue"),
};

export default globals;
